<template>
    <section>
        <section id="slides-container" class="generic-wrapper">
            <!--<div class="slides-text-wrapper">-->
                <!--<h1 class="title">Bienvenido</h1>-->
            <!--</div>-->
            <!--<img src="../assets/images/icons/logo-hotel.png" alt="Las Hamacas Logo"-->
                 <!--class="logo">-->
            <!--<div class="slides-text-wrapper">-->
                <!--<p class="content">Disfruta del mejor ambiente en la ciudad mas bella de <br>-->
                    <!--Honduras</p>-->
            <!--</div>-->

            <!--<div id="reservation-search">-->
                <!--<form action="" id="reservation-form" @submit.prevent="redirectToSearch">-->
                    <!--<h3>Reserva Ya!</h3>-->
                    <!--<div class="input-wrapper">-->
                        <!--<label for="check-in">Check-in</label>-->
                        <!--<input type="text" id="check-in" name="check_in">-->
                    <!--</div>-->

                    <!--<div class="input-wrapper">-->
                        <!--<label for="check-out">Check-out</label>-->
                        <!--<input type="text" id="check-out" name="check_out">-->
                    <!--</div>-->
                    <!--<ul class="error-list" v-if="errors.length > 0">-->
                        <!--<li v-for="error in errors">{{ error }}</li>-->
                    <!--</ul>-->
                    <!--<input type="submit" value="Ver Disponibilidad" class="reservation-submit">-->
                <!--</form>-->
            <!--</div>-->
        </section>

        <section id="content-container">
            <h2 class="page-subtitle">¡Ven y Conoce la bella ciudad de La Ceiba!</h2>
            <p class="body-text">
                Hotel Las Hamacas es un hotel familiar ubicado en la ciudad de La Ceiba,
                y se encuentra a 5km del centro de la ciudad, y a tan solo
                9km de las playas de Corozal.
            </p>
            <h1 id="main-title">Huéspedes Satisfechos</h1>
            <div class="counters-wrapper">
                <div class="counter">
                    <h3 class="title">Calificación en TripAdvisor</h3>
                    <ICountUp class="number"
                              :startVal="0"
                              :endVal="4.0"
                              :decimals="1"
                              :duration="3"
                              :options="{useEasing: true, easingFn: this.$outQuinticFn}"
                    @ready="onReady"/><span class="number-base"> / 5</span>
                </div>

                <div class="counter">
                    <h3 class="title">Calificación en Booking.com</h3>
                    <ICountUp class="number"
                              :startVal="0"
                              :endVal="8.5"
                              :decimals="1"
                              :duration="3"
                              :options="{useEasing: true, easingFn: this.$outQuinticFn}"
                    @ready="onReady"/><span class="number-base"> / 10</span>
                </div>
            </div>
            <h1 class="subtitle">Nuestros Huéspedes Dicen...</h1>
            <Review />
        </section>
    </section>

</template>

<script>
    // @ is an alias to /src
    import ICountUp from 'vue-countup-v2'
    import Review from "../components/Review";

    let check_in_picker;
    let check_out_picker;


    export default {
        name: 'home',
        components: {
            Review,
            ICountUp,
        },
        data() {
            return {
                check_in: '',
                check_out: '',
                errors: [],
            }
        },
        mounted() {
            check_in_picker = new this.$pikaday({
                field: document.getElementById('check-in'),
                format: 'DD MMM YYYY',
                minDate: new Date(),
                i18n: this.$i18n_picker,
                onSelect: () => {
                    this.check_in = check_in_picker.toString('YYYY-MM-DD');
                }
            });
            check_in_picker.setDate(this.$moment().format());
            check_out_picker = new this.$pikaday({
                field: document.getElementById('check-out'),
                format: 'DD MMM YYYY',
                minDate: new Date(),
                i18n: this.$i18n_picker,
                onSelect: () => {
                    this.check_out = check_out_picker.toString('YYYY-MM-DD');
                }
            });
            check_out_picker.setDate(this.$moment().add(1, 'days').format())
        },
        methods: {
            redirectToSearch() {
                this.errors = [];
                if ((new Date(this.check_out)) <= (new Date(this.check_in))) {
                    this.errors.push('La fecha de salida debe ser mayor a la fecha de llegada');
                    return;
                }
                this.$router.push({
                    name: 'availability',
                    query: {
                        check_in: this.check_in,
                        check_out: this.check_out,
                        adults: this.adults,
                        children: this.children,
                    }
                });
            },
            onReady(instance, CountUp) {
                const that = this;
                instance.update(that.endVal)
            }
        }
    }
</script>

<style scoped>
    /**
    Slides Styles
     */
    #slides-container {
        height: 480px;
        z-index: 1;
        position: relative;
        background-image: url("../assets/images/site-landing.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 0;
    }

    .slides-text-wrapper {
        padding: 10px 15px;
        color: #FFF;
        background-color: rgba(51, 51, 51, 0.70);
    }

    .slides-text-wrapper .title {
        font-size: 1.875rem;
        font-weight: 500;
        margin: 0;
        text-align: center;
    }

    #slides-container .logo {
        width: 300px;
        height: auto;
    }

    .slides-text-wrapper .content {
        font-size: 1.375rem;
        font-weight: 500;
        margin: 0;
        text-align: center;
    }

    #reservation-search {
        width: 400px;
        box-shadow: 0 2px 5px #c9c9c9;
        background-color: #FFF;
        border-radius: 2px;
        margin-right: 50px;
        padding: 15px 15px;
        box-sizing: border-box;
        align-self: center;
    }

    #reservation-form {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: stretch;
    }

    #reservation-form h3 {
        text-align: center;
        border-bottom: 2px solid #643229;
        font-size: 1.1875rem;
        padding: 10px 0;
        margin: 0 0 10px 0;
    }

    #reservation-form .input-wrapper {
        margin-bottom: 10px;
    }

    #reservation-form .inline-wrapper {
        display: flex;
    }

    #reservation-form .error-list {
        padding: 0;
        margin: 5px 0;
        list-style-type: none;
        color: #F00;
        font-weight: 500;
        text-align: center;
    }

    #reservation-form .reservation-submit {
        padding: 15px 0;
        background-color: #643229;
        color: #F1DDC4;
        font-size: 1rem;
        font-weight: 500;
    }

    /**
    Content Styles
     */

    #content-container {
        background-color: #FFF;
        min-height: 350px;
        padding: 30px 30px;
        z-index: 9;
        position: relative;
    }

    #content-container .body-text {
        line-height: 2.5rem;
        margin-bottom: 80px;
        text-align: center;
        font-size: 1.3rem;
    }

    #main-title {
        font-size: 2.7rem;
        text-align: center;
        font-weight: 500;
        margin: 0;
    }

    #content-container .subtitle {
        font-size: 2.3rem;
        text-align: center;
        font-weight: 500;
        margin: 100px 0 0 0;
    }

    #content-container .counters-wrapper {
        display: flex;
        justify-content: space-evenly;
        margin-top: 50px;
    }

    #content-container .counter {
        text-align: center;
    }

    #content-container .counter .title {
        font-size: 1.5rem;
        margin: 0;
        font-weight: 500;
        border-bottom: 1px solid #999;
        padding-bottom: 10px;
    }

    #content-container .counter .number {
        font-size: 5rem;
        color: #4d63bc;
    }

    #content-container .counter .number-base {
        font-size: 3rem;
        color: #4d63bc;
    }

    /***********************************************************************/

    @media only screen and (min-width: 320px) and (max-width: 767px) {

        #slides-text-wrapper {
            margin: 0 10px;
        }

        #content-container {
            padding: 30px 15px;
        }

        #rafting-tour {
            flex-direction: column;
        }

        #rafting-tour .promo-info .data-wrapper {
            margin-top: 50px;
        }

        #rafting-tour .promo-image img {
            max-width: 350px;
        }

        #rafting-tour .promo-info .data-wrapper:first-child {
            margin-top: 50px;
        }

        #content-container .counters-wrapper {
            flex-direction: column;
            margin-top: 50px;
        }

        #content-container .counter:not(:first-child) {
            margin-top: 30px;
        }

        #reservation-search {
            display: none;
            position: fixed;
            margin: 0;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
        }
        #content-container {

        }
    }
</style>
